const getters = {
	total: (state) => state.total,
	sessions: (state) => state.sessions
}

export default getters
